(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[80],{

/***/ 69101:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournaments",
      function () {
        return __webpack_require__(96326);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TournamentStatusChip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66198);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93594);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28879);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);







var TournamentStatusChip = function(_param) {
    var tournamentStatus = _param.tournamentStatus, checkinStart = _param.checkinStart, checkinEnd = _param.checkinEnd, startDate = _param.startDate, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "tournamentStatus",
        "checkinStart",
        "checkinEnd",
        "startDate"
    ]);
    var getStatus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var checkInOpen = dayjs__WEBPACK_IMPORTED_MODULE_3___default()().isAfter(dayjs__WEBPACK_IMPORTED_MODULE_3___default()(checkinStart));
        var checkInOver = dayjs__WEBPACK_IMPORTED_MODULE_3___default()().isAfter(checkinEnd);
        var startingSoon = dayjs__WEBPACK_IMPORTED_MODULE_3___default()().isAfter(dayjs__WEBPACK_IMPORTED_MODULE_3___default()(startDate).subtract(5, "minute"));
        if (tournamentStatus === _generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TournamentStatus.Draft */ .C5.Draft) return {
            label: "Draft",
            type: "default"
        };
        if (tournamentStatus === _generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TournamentStatus.Finished */ .C5.Finished) return {
            label: "Finished",
            type: "default"
        };
        if (tournamentStatus === _generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TournamentStatus.Cancelled */ .C5.Cancelled) return {
            label: "Cancelled",
            type: "error"
        };
        if (tournamentStatus === _generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TournamentStatus.Started */ .C5.Started) return {
            label: "Running",
            type: "primary"
        };
        if (checkInOver) {
            return {
                label: "Starting Soon",
                type: startingSoon ? "error" : "default"
            };
        }
        if (tournamentStatus === _generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .TournamentStatus.Published */ .C5.Published) return {
            label: checkInOpen ? "Check-in open" : "Registration",
            type: "default"
        };
        return {
            label: "Unknown",
            type: "default"
        };
    }, [
        tournamentStatus,
        checkinStart,
        checkinEnd,
        startDate
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(getStatus()), status = ref[0], setStatus = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setStatus(getStatus());
    }, [
        getStatus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        label: status.label,
        color: status.type,
        variant: status.type === "default" ? "outlined" : "filled"
    }, rest));
};


/***/ }),

/***/ 96326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ tournaments; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./components/tournament/tournamentCard/tournamentCard.module.scss
var tournamentCard_module = __webpack_require__(44278);
var tournamentCard_module_default = /*#__PURE__*/__webpack_require__.n(tournamentCard_module);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(67550);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(17377);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(66198);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(92725);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(62197);
// EXTERNAL MODULE: ./components/ui/icon/index.tsx
var icon = __webpack_require__(66303);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/DnsOutlined.js
var DnsOutlined = __webpack_require__(92552);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/DevicesOutlined.js
var DevicesOutlined = __webpack_require__(6160);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/GamepadOutlined.js
var GamepadOutlined = __webpack_require__(18290);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/LanguageOutlined.js
var LanguageOutlined = __webpack_require__(61970);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/PeopleOutlined.js
var PeopleOutlined = __webpack_require__(18313);
// EXTERNAL MODULE: ./components/tournament/tournamentHeader/tournamentStatusChip.tsx
var tournamentStatusChip = __webpack_require__(92346);
// EXTERNAL MODULE: ./hooks/useWindowSize.tsx
var useWindowSize = __webpack_require__(6772);
;// CONCATENATED MODULE: ./components/tournament/tournamentCard/infoTag.tsx





var InfoTag = function(param) {
    var icon = param.icon, content = param.content, children = param.children;
    var isMobile = (0,useWindowSize/* useWindowSize */.i)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        className: (tournamentCard_module_default()).infoPaper,
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: isMobile ? "labelSmall" : "labelMedium",
                className: (tournamentCard_module_default()).infoLabel,
                children: content !== null && content !== void 0 ? content : children
            })
        ]
    });
};

// EXTERNAL MODULE: ./generated/graphql.tsx + 18 modules
var graphql = __webpack_require__(93594);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Shield.js
var Shield = __webpack_require__(33747);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/SportsEsports.js
var SportsEsports = __webpack_require__(80518);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Gavel.js
var Gavel = __webpack_require__(32712);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(24032);
;// CONCATENATED MODULE: ./components/tournament/tournamentCard/roleInfo.tsx







var RoleInfo = function(param) {
    var userRoles = param.userRoles, className = param.className;
    if (!(userRoles === null || userRoles === void 0 ? void 0 : userRoles.length)) return null;
    var isPlayer = userRoles.includes(graphql/* ParticipantRoleType.Player */.lj.Player);
    var isStaff = userRoles.includes(graphql/* ParticipantRoleType.Host */.lj.Host) || userRoles.includes(graphql/* ParticipantRoleType.Moderator */.lj.Moderator);
    var isAdmin = userRoles.includes(graphql/* ParticipantRoleType.Admin */.lj.Admin);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            alignItems: "center"
        },
        className: className,
        children: [
            isAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: "Admin",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shield/* default */.Z, {
                    color: "primary"
                })
            }),
            isStaff && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: "Staff",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gavel/* default */.Z, {
                    color: "primary"
                })
            }),
            isPlayer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: "Player",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SportsEsports/* default */.Z, {
                    color: "primary"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/tournament/tournamentCard/index.tsx



















var ref;
var TournamentCard = function(_param) {
    var tournament = _param.tournament, toHub = _param.toHub, backgroundSrc = _param.backgroundSrc, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "tournament",
        "toHub",
        "backgroundSrc",
        "className"
    ]);
    var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: "/tournament/".concat(tournament.id).concat(toHub ? "/hub" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: classnames_default()((tournamentCard_module_default()).card, className)
        }, rest), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                className: (tournamentCard_module_default()).cardContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (tournamentCard_module_default()).picture,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tournamentStatusChip/* TournamentStatusChip */.z, {
                                tournamentStatus: tournament.status,
                                checkinStart: tournament.checkinStart,
                                checkinEnd: tournament.checkinEnd,
                                startDate: tournament.date,
                                className: (tournamentCard_module_default()).statusChip
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: dayjs_min_default()(tournament.date).format("HH:mm DD/MM/YYYY"),
                                variant: "outlined",
                                className: (tournamentCard_module_default()).dateChip
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    background: 'no-repeat center / cover url("'.concat(backgroundSrc, '")'),
                                    height: 180,
                                    borderRadius: "inherit"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (tournamentCard_module_default()).info,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (tournamentCard_module_default()).infoGrid,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleOutlined/* default */.Z, {
                                            className: (tournamentCard_module_default()).infoIcon
                                        }),
                                        content: "".concat(tournament.playersCount, "/").concat(tournament.maxPlayers, " Payers")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GamepadOutlined/* default */.Z, {
                                            className: (tournamentCard_module_default()).infoIcon
                                        }),
                                        content: "".concat(tournament.game.title, " - ").concat((ref1 = tournament.gameMode) === null || ref1 === void 0 ? void 0 : ref1.name)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DnsOutlined/* default */.Z, {
                                            className: (tournamentCard_module_default()).infoIcon
                                        }),
                                        content: (ref2 = tournament.region) === null || ref2 === void 0 ? void 0 : ref2.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
                                            variant: "bracketHollow",
                                            className: (tournamentCard_module_default()).infoIcon,
                                            color: (tournamentCard_module_default()).muiOnSurfaceVariant
                                        }),
                                        content: ((ref3 = tournament.stages) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.type) === "SINGLE" && "Single Elimination"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DevicesOutlined/* default */.Z, {
                                            className: (tournamentCard_module_default()).infoIcon
                                        }),
                                        content: tournament === null || tournament === void 0 ? void 0 : (ref5 = tournament.platforms) === null || ref5 === void 0 ? void 0 : ref5.map(function(platform) {
                                            return platform === null || platform === void 0 ? void 0 : platform.name;
                                        }).join(", ")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageOutlined/* default */.Z, {
                                            className: (tournamentCard_module_default()).infoIcon
                                        }),
                                        content: (ref6 = tournament.language) === null || ref6 === void 0 ? void 0 : ref6.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (tournamentCard_module_default()).titleAndHost,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        alt: "Organizer Profile Picture",
                                        src: (ref = tournament === null || tournament === void 0 ? void 0 : (ref7 = tournament.hostUser) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.linkedAccounts) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.avatar) !== null && ref !== void 0 ? ref : undefined,
                                        className: (tournamentCard_module_default()).avatar
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "bodyMedium",
                                                sx: {
                                                    fontWeight: 700
                                                },
                                                children: tournament.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "labelSmall",
                                                className: (tournamentCard_module_default()).host,
                                                children: tournament.hostUser.displayName
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoleInfo, {
                                className: (tournamentCard_module_default()).rolesInfo,
                                userRoles: tournament.userRoles
                            })
                        ]
                    })
                ]
            })
        }))
    });
};

// EXTERNAL MODULE: ./pages/tournaments/index.module.scss
var index_module = __webpack_require__(5148);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./hooks/useAuth.ts
var useAuth = __webpack_require__(25487);
// EXTERNAL MODULE: ./components/ui/loader/index.tsx
var loader = __webpack_require__(29166);
// EXTERNAL MODULE: ../../node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(62202);
;// CONCATENATED MODULE: ./handlers/errorHandler.tsx

var handleError = function(error) {
    var graphQLErrors = error.graphQLErrors;
    if (graphQLErrors) {
        graphQLErrors.forEach(function(param) {
            var extensions = param.extensions, message = param.message;
            if ((extensions === null || extensions === void 0 ? void 0 : extensions.code) === "UNAUTHENTICATED") return;
            dist/* toast.error */.Am.error(message, {
                id: message,
                duration: 2500
            });
        });
    }
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Tabs/Tabs.js + 8 modules
var Tabs = __webpack_require__(38484);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(78287);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(62048);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(22531);
// EXTERNAL MODULE: ./components/tournament/tournamentSearch/index.tsx + 2 modules
var tournament_tournamentSearch = __webpack_require__(7973);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/AddRounded.js
var AddRounded = __webpack_require__(80288);
// EXTERNAL MODULE: ../../node_modules/fuse.js/dist/fuse.esm.js
var fuse_esm = __webpack_require__(71659);
// EXTERNAL MODULE: ./components/ui/empty/index.tsx
var empty = __webpack_require__(29716);
;// CONCATENATED MODULE: ./pages/tournaments/index.tsx














var Index = function() {
    var user = (0,useAuth/* useAuth */.a)().user;
    var ref = (0,useWindowSize/* useWindowSize */.i)(), breakpoint = ref.breakpoint, isMobile = ref.isMobile;
    var ref1 = (0,react.useState)(1), currentTab = ref1[0], setCurrentTab = ref1[1];
    var ref2 = (0,react.useState)(""), tournamentSearch = ref2[0], setTournamentSearch = ref2[1];
    var ref3 = (0,react.useState)([]), renderedTournaments = ref3[0], setRenderedTournaments = ref3[1];
    var ref4 = (0,graphql/* useGetTournamentsQuery */.R_)({
        onError: function(error) {
            return handleError(error);
        }
    }), tournamentsData = ref4.data, tournamentsLoading = ref4.loading;
    var ref5 = (0,graphql/* useGetTournamentsQuery */.R_)({
        variables: {
            userHasParticipantRoles: [
                graphql/* ParticipantRoleType.Host */.lj.Host,
                graphql/* ParticipantRoleType.Admin */.lj.Admin,
                graphql/* ParticipantRoleType.Player */.lj.Player,
                graphql/* ParticipantRoleType.Moderator */.lj.Moderator, 
            ]
        },
        skip: user === undefined,
        onError: function(error) {
            return handleError(error);
        }
    }), participatingData = ref5.data, participatingLoading = ref5.loading;
    (0,react.useEffect)(function() {
        var renderTournaments = function(participating) {
            var tournaments = participating ? participatingData === null || participatingData === void 0 ? void 0 : participatingData.tournaments : tournamentsData === null || tournamentsData === void 0 ? void 0 : tournamentsData.tournaments;
            if (!(tournaments === null || tournaments === void 0 ? void 0 : tournaments.length)) {
                if (participating) {
                    return [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                            className: (index_module_default()).empty,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* Empty */.H, {
                                title: "You are not participating in any tournaments..."
                            })
                        }, "not_participating"), 
                    ];
                }
                return [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                        className: (index_module_default()).empty,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* Empty */.H, {
                            title: "Unable to find tournaments..."
                        })
                    }, "no_tournaments"), 
                ];
            }
            var fuse = new fuse_esm/* default */.Z(tournaments, {
                includeScore: true,
                threshold: 0.6,
                keys: [
                    "title",
                    "hostUser.displayName",
                    "game.title"
                ]
            });
            var searchedTournaments = tournamentSearch.length > 0 ? fuse.search(tournamentSearch.toString()).map(function(result) {
                return result.item;
            }) : tournaments;
            if (!(searchedTournaments === null || searchedTournaments === void 0 ? void 0 : searchedTournaments.length)) {
                return [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                        className: (index_module_default()).empty,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* Empty */.H, {
                            title: "No tournaments match you current search...",
                            description: "Create a tournament to liven up the place!"
                        })
                    }, "not_search_match"), 
                ];
            }
            return searchedTournaments === null || searchedTournaments === void 0 ? void 0 : searchedTournaments.map(function(element) {
                if (!element) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TournamentCard, {
                    tournament: element,
                    className: (index_module_default()).tournamentCard,
                    backgroundSrc: "/assets/images/thisIsABanner.png",
                    toHub: element.hostUser.id === (user === null || user === void 0 ? void 0 : user.id),
                    "data-cy": "tournamentCard"
                }, element.id);
            });
        };
        var ref;
        setRenderedTournaments((ref = renderTournaments(currentTab === 2)) !== null && ref !== void 0 ? ref : []);
    }, [
        currentTab,
        tournamentSearch,
        user === null || user === void 0 ? void 0 : user.id,
        participatingData === null || participatingData === void 0 ? void 0 : participatingData.tournaments,
        tournamentsData === null || tournamentsData === void 0 ? void 0 : tournamentsData.tournaments, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (index_module_default()).discovery,
        children: [
            !isMobile && breakpoint !== "lg" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (index_module_default()).searchAndFilter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                        className: (index_module_default()).search,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tournament_tournamentSearch/* TournamentSearch */.o, {
                            value: tournamentSearch,
                            onChange: function(e) {
                                return setTournamentSearch(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                        className: (index_module_default()).filter,
                        children: "Filters (Coming Soon) ™"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (index_module_default()).tournamentLists,
                children: [
                    breakpoint === "lg" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                        className: (index_module_default()).search,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tournament_tournamentSearch/* TournamentSearch */.o, {
                            value: tournamentSearch,
                            onChange: function(e) {
                                return setTournamentSearch(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (index_module_default()).navigation,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                sx: {
                                    flex: "2",
                                    borderRadius: "0.75rem"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                                    centered: true,
                                    value: currentTab,
                                    onChange: function(_, value) {
                                        return setCurrentTab(value);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                            label: "All Tournaments",
                                            value: 1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                            label: "My Tournaments",
                                            value: 2,
                                            "data-cy": "userTournaments"
                                        })
                                    ]
                                })
                            }),
                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                className: (index_module_default()).create,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "/tournament/new",
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddRounded/* default */.Z, {}),
                                    children: "Create Tournament"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (index_module_default()).tournamentList,
                        children: tournamentsLoading || participatingLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* Loader */.a, {}) : renderedTournaments
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fab/* default */.Z, {
                variant: "extended",
                "aria-label": "Create",
                color: "primary",
                className: (index_module_default()).createFab,
                href: "/tournament/new",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddRounded/* default */.Z, {}),
                    "Create"
                ]
            })
        ]
    });
};
/* harmony default export */ var tournaments = (Index);


/***/ }),

/***/ 44278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"tournamentCard_idTarget__1ZSf_","fabulousText":"tournamentCard_fabulousText__RFOnt","rainbow":"tournamentCard_rainbow__PNbDY","errorText":"tournamentCard_errorText__Atnjy","card":"tournamentCard_card__54TWk","cardContent":"tournamentCard_cardContent__1QFPS","picture":"tournamentCard_picture__Aq9Qd","statusChip":"tournamentCard_statusChip__Mdp_C","dateChip":"tournamentCard_dateChip__NMQf4","info":"tournamentCard_info__iquKN","infoGrid":"tournamentCard_infoGrid__VItSj","infoPaper":"tournamentCard_infoPaper__Hiv9I","infoIcon":"tournamentCard_infoIcon__RjblH","infoLabel":"tournamentCard_infoLabel__j2k_J","titleAndHost":"tournamentCard_titleAndHost__gsz7b","avatar":"tournamentCard_avatar__B7hlW","host":"tournamentCard_host__ywwa3","rolesInfo":"tournamentCard_rolesInfo__oAW8O"};

/***/ }),

/***/ 5148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"tournaments_idTarget__3ddSe","fabulousText":"tournaments_fabulousText__kXdjn","rainbow":"tournaments_rainbow__Xvvua","errorText":"tournaments_errorText__yh3ea","discovery":"tournaments_discovery__Xpydb","searchAndFilter":"tournaments_searchAndFilter__YPogs","filter":"tournaments_filter__K8FNs","empty":"tournaments_empty__clo_G","tournamentLists":"tournaments_tournamentLists__qQn2E","navigation":"tournaments_navigation__fQV9_","create":"tournaments_create__3_keK","tournamentList":"tournaments_tournamentList__QO5w4","tournamentCard":"tournaments_tournamentCard__wOpZD","createFab":"tournaments_createFab__7EsM4","search":"tournaments_search__OpMR4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [40,490,774,888,179], function() { return __webpack_exec__(69101); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);